import React, { createContext, useState, useEffect } from 'react';

export const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({});
  const fetchConfig = async () => {
  const res = await fetch('https://chungwhav2.tnf.cl/api/configuracion');
    const data = await res.json();
    const configObj = {};
    data.forEach(item => {
      configObj[item.clave] = item.valor;
    });
    setConfig(configObj);
  };
  useEffect(() => {
    fetchConfig();
  }, []);
  const updateConfig = async (clave, valor) => {
  await fetch('https://chungwhav2.tnf.cl/api/configuracion', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ clave, valor })
    });
    fetchConfig();
  };
  return (
    <ConfigContext.Provider value={{ config, updateConfig, fetchConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};
